<template>
  <div
    class="relative p-3 border rounded-lg hover:shadow-md transition-all duration-200 cursor-move bg-white"
    :class="{
      'border-gray-300 shadow-sm': bond.isBenchmark,
      'border-gray-200': !bond.isBenchmark,
      'opacity-50 scale-95': isDragged,
    }"
    draggable="true"
    @dragstart="$emit('dragstart', $event, bond)"
    @dragend="$emit('dragend')"
  >
    <div class="mb-2">
      <!-- 종목명과 버튼들을 같은 행에 배치 -->
      <div class="flex items-center justify-between">
        <div
          class="font-semibold text-gray-900 text-sm leading-tight flex-1 min-w-0"
        >
          {{ extractBondSeries(bond.bondName) }}
        </div>
        <div class="flex items-center space-x-1 ml-2">
          <!-- 지표채권 별표 -->
          <button
            @click="$emit('toggle-benchmark', bond)"
            class="text-gray-400 hover:text-yellow-500 p-1 rounded transition-colors focus:outline-none"
            :class="bond.isBenchmark ? 'text-yellow-500' : 'text-gray-300'"
          >
            <i class="fas fa-star text-sm"></i>
          </button>
          <!-- 수정 버튼 -->
          <button
            @click="$emit('edit', bond)"
            class="text-gray-400 hover:text-blue-600 p-1 rounded-full hover:bg-blue-50 transition-colors"
          >
            <i class="fas fa-edit text-xs"></i>
          </button>
        </div>
      </div>
      <!-- 코드 -->
      <div class="text-xs text-gray-500 font-mono mt-1">
        {{ bond.code }}
      </div>
    </div>

    <div class="space-y-1 text-xs text-gray-600 mb-2">
      <div class="flex justify-between">
        <span>만기:</span>
        <span class="font-medium">{{ formatDate(bond.maturityDate) }}</span>
      </div>
      <div class="flex justify-between">
        <span>잔존:</span>
        <span class="font-medium">{{
          calculateRemainingTerm(bond.maturityDate)
        }}</span>
      </div>
    </div>

    <div class="text-center">
      <div class="text-base font-bold text-gray-900">
        {{ formatYield(bond.yield) }}%
      </div>
    </div>
  </div>
</template>

<script>
import {
  formatDate,
  formatYield,
  extractBondSeries,
  calculateRemainingTerm,
} from '@/utils/bondFormatters';

export default {
  name: 'KtbBondCard',
  props: {
    bond: {
      type: Object,
      required: true,
    },
    isDragged: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['dragstart', 'dragend', 'toggle-benchmark', 'edit'],
  setup() {
    return {
      formatDate,
      formatYield,
      extractBondSeries,
      calculateRemainingTerm,
    };
  },
};
</script>
